import { useEffect, useMemo, useRef, useState } from "react";
import { Button, message } from 'antd';
import { InboxOutlined } from "@ant-design/icons";
import { useEditorContext } from "../EditorContext";
import { useRequest } from "ahooks";
import { UploadImage, CreateFolder } from "../Service/MediaMakerService";

const toRGBA = ({ r, g, b, a }) => `rgba(${r}, ${g}, ${b}, ${a})`;


export default ({ data }) => {
  const localFileKey = localStorage.getItem("fileKey");
  const firstFileKey = localFileKey? localFileKey: process.env.REACT_APP_FILE_KEY;
  const {
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
    borderWidth,
    borderColor = {},
    borderStyle,
    borderRadius,
    shadowSize = 0,
    shadowDirection = 0,
    shadowBlur = 0,
    shadowColor = {},
    autoWidth,
    width,
    alt,
    contentID,
    linkUrlType,
    linkUrl,
    linkNewTab = false,
    align,
    imageLink = "",
    url,
  } = data;
  const { shareRefs, notifySubscriber } = useEditorContext();
  const [isDragging, setIsDragging] = useState(false);

  const { xShadow, yShadow } = useMemo(() => {
    const oneDeg = (Math.PI * 2) / 360;
    const revertDeg = 360 - shadowDirection;
    const x = Math.sin(revertDeg * oneDeg) * shadowSize;
    const y = Math.cos(revertDeg * oneDeg) * shadowSize;
    return {
      xShadow: x.toFixed(0),
      yShadow: y.toFixed(0),
    };
  }, [shadowDirection, shadowSize]);

  const buttonRef = useRef(null);

  useEffect(() => {
      const button = buttonRef.current;
      if (button){
        const buttonWidth = button?.offsetWidth;
        const buttonHeight = button?.offsetHeight;

        // 计算按钮的最大字体大小，以确保文本不会超过按钮边框
        const maxFontSize = Math.min(buttonWidth, buttonHeight) * 0.3; // 调整字体大小的比例，例如 0.8

        // 设置按钮内部文本的字体大小
        button.style.fontSize = `${maxFontSize}px`;
      }
  }, []);

  useEffect(() => {
    if (shareRefs?.updateSelectContent){
        shareRefs?.updateSelectContent();
    }
  }, [shareRefs?.handleInsertPath])
  
  const { run: runUploadImage } = useRequest(UploadImage, {
    manual: true, 
    onSuccess: (res)=>{
      // force rerender config form;
      shareRefs.selectedNode = null;
      notifySubscriber("NODE_SELECT");
      data.url = res.file_link;
    },
    onError: (err)=>{
      message.error(err.message);
    }
  })

  const { run: runCreateFolder } = useRequest(CreateFolder, {
    manual: true
  })
  
  return (
    <div
      id={contentID}
      style={{
        paddingTop,
        paddingBottom,
        paddingRight,
        paddingLeft,
        borderColor: toRGBA(borderColor),
        borderStyle,
        borderWidth,
        borderRadius,
        boxShadow: `${xShadow}px ${yShadow}px ${shadowBlur}px ${toRGBA(shadowColor)}`,
      }}
    >
      {imageLink ? (
        <p>
          <a
            target="_blank"
            href={imageLink}
            linktype="image"
            imgurl={url}
            tab="outerlink"
            data-linktype="1"
          >
            <span className="js_jump_icon h5_image_link">
              <img
                style={{
                  width: "100%",
                  height: "auto",
                  verticalAlign: "middle",
                  boxSizing: "border-box",
                }}
                data-ratio="1"
                data-s="300,640"
                data-w="940"
                src={url}
              />
            </span>
          </a>
        </p>
      ) : (
        <div 
          style={{ 
            backgroundColor: isDragging? '#e6e6e6': (!data?.url ? "#fafafa": 'transparent'),
            width: '100%',
            height: !data?.url ? "150px": "100%",
            textAlign: 'center',
          }}
          onDragOver={()=>{setIsDragging(true)}}
          onDragLeave={()=>{setIsDragging(false)}}
          onDrop={(e)=>{
            setIsDragging(false);
            e.preventDefault();
            // prevent drag compoent not work.
            if (!e.dataTransfer.types.includes("Files")) {
              return;
            }
            e.stopPropagation();
            runCreateFolder({
              "folder_name": "editor_images",
              "file_key": firstFileKey
            });
            let formData = new FormData();
            formData.append("file", e.dataTransfer.files[0]);
            formData.append("file_key", `${firstFileKey}/editor_images`);
            runUploadImage(formData);
            setIsDragging(false);
          }}
        >
          {data?.url ? (
            <div style={{ display: "flex", justifyContent: `${align?align:"center"}` }}>
              <img
                src={url}
                alt={`${alt?alt: "Ri+"}`}
                style={{ 
                  width: autoWidth? "auto": `${width?width:100}%`,
                  maxWidth: "100%"
                }}
                data-action={{linkUrlType: linkUrlType, linkUrl: linkUrl}}
              />
            </div>
          ): (
            <>
            <p style={{color: "#40a9ff", fontSize: "48px"}}>
              <InboxOutlined />
            </p>
            <p className="ant-upload-text" style={{ marginTop: "-10px" }}>Drag image to area</p>
            <div>
              <Button
                block
                style={{
                  position: "absolute",
                  top: "120px", width: "56px", height: "28px",
                  transform: "translate(-50%, -50%)",
                  color: "#fff",
                  backgroundColor: "#bdc5c8",
                  border: "none",
                  cursor: "pointer",
                  borderRadius: "3px"
                }}
                onClick={()=>{
                  shareRefs.triggerFileManger(true);
                  shareRefs.handleInsertPath = (url)=>{
                    shareRefs.selectedNode = null;
                    notifySubscriber("NODE_SELECT");
                    data.url = url;
                  };
                }}
              >
                <span style={{ marginLeft: "-9px" }}>Browse</span>
              </Button>
            </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};
